class MegaMenuNav {
  constructor(root) {
    this.root = root;
    this.items = Array.from(root.querySelectorAll('[data-mega-menu-item]'));
    this.stickyOffset = parseInt(root.dataset.stickyOffset || '180', 10);
    this.activeItem = null;
    this.isDesktop = window.matchMedia('(min-width: 990px)').matches;

    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);

    this.deferPanelImages();
    this.bindItems();
    this.bindStickyScroll();
    window.addEventListener('resize', this.onResize);
  }

  deferPanelImages() {
    this.root.querySelectorAll('.mega-menu-nav__panel img[src]').forEach((img) => {
      if (img.dataset.deferredSrc) return;
      img.dataset.deferredSrc = img.currentSrc || img.src;
      if (img.srcset) img.dataset.deferredSrcset = img.srcset;
      img.removeAttribute('srcset');
      img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    });
  }

  activatePanelImages(panel) {
    panel.querySelectorAll('img[data-deferred-src]').forEach((img) => {
      img.src = img.dataset.deferredSrc;
      if (img.dataset.deferredSrcset) img.srcset = img.dataset.deferredSrcset;
      delete img.dataset.deferredSrc;
      delete img.dataset.deferredSrcset;
    });
  }

  onResize() {
    this.isDesktop = window.matchMedia('(min-width: 990px)').matches;
    if (!this.isDesktop) {
      this.closeAll();
    }
  }

  bindItems() {
    this.items.forEach((item) => {
      const trigger = item.querySelector('.mega-menu-nav__trigger');
      const panel = item.querySelector('.mega-menu-nav__panel');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.toggleItem(item);
      });
    });

    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onKeydown);
  }

  bindStickyScroll() {
    this.stickyHeader = document.querySelector('sticky-header');
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();
  }

  onScroll() {
    if (!this.isDesktop) {
      this.root.style.removeProperty('--mega-menu-sticky-top');
      return;
    }
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const headerHeight = this.stickyHeader ? this.stickyHeader.offsetHeight : 0;
    const nextTop = scrollTop > headerHeight ? '0px' : `${this.stickyOffset}px`;
    this.root.style.setProperty('--mega-menu-sticky-top', nextTop);
  }

  toggleItem(item) {
    if (this.activeItem === item) {
      this.closeAll();
      return;
    }
    this.openPanel(item);
  }

  openPanel(item) {
    this.closeAll(false);
    const trigger = item.querySelector('.mega-menu-nav__trigger');
    const panel = item.querySelector('.mega-menu-nav__panel');
    if (!trigger || !panel) return;

    item.classList.add('mega-menu-nav__item--open');
    trigger.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    this.activatePanelImages(panel);
    this.activeItem = item;
  }

  closeAll(resetOpenItem = true) {
    this.items.forEach((item) => {
      const trigger = item.querySelector('.mega-menu-nav__trigger');
      const panel = item.querySelector('.mega-menu-nav__panel');
      item.classList.remove('mega-menu-nav__item--open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    });
    if (resetOpenItem) this.activeItem = null;
  }

  onDocumentClick(event) {
    if (!this.root.contains(event.target)) this.closeAll();
  }

  onKeydown(event) {
    if (event.key === 'Escape') this.closeAll();
  }
}

function initMegaMenuNav() {
  if (document.documentElement.classList.contains('navigation-mode-custom')) {
    document.querySelectorAll('[data-mega-menu-nav]').forEach((root) => {
      if (!root.dataset.megaMenuInit) {
        root.dataset.megaMenuInit = 'true';
        new MegaMenuNav(root);
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', initMegaMenuNav);
document.addEventListener('shopify:section:load', initMegaMenuNav);
